import { memo } from 'react';
import { SnackBar } from '@core-web/ui';
import { ISnackBar } from '@core-web/ui/SnackBar';

export const SnackBarWrapper = memo(
  (props: ISnackBar) => {
    const { open, message, onClose, ...rest } = props;
    return <SnackBar open={open} message={message} variant={props.variant} onClose={onClose} {...rest} />;
  },
  (prevProps, nextProps) => {
    if (nextProps.open !== prevProps.open) {
      return false;
    }
    return true;
  }
);

SnackBarWrapper.displayName = 'SnackBarWrapper';

export default SnackBarWrapper;
